import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["schema", "previewForm", "schemaInput"];

  preview() {
    this.schemaInputTarget.value = this.schemaTarget.value;
    this.previewFormTarget.requestSubmit();
  }
}
